import React from 'react';

export const SvgVideocamOff = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.001 4.54a.996.996 0 111.41-1.41l16.32 16.33a.996.996 0 11-1.41 1.41l-2.48-2.48c-.16.1-.34.18-.55.18h-12c-.55 0-1-.45-1-1v-10c0-.55.45-1 1-1h.73l-2.02-2.03zm18.29 4.94v5.29c0 .89-1.08 1.34-1.7.71l-8.91-8.91h5.61c.55 0 1 .45 1 1v3.5l2.29-2.3c.63-.63 1.71-.18 1.71.71z"
      fill="currentColor"
    />
  </svg>
);
